import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
            name: '张经理',
            avatar: '',
            brand: '示例品牌',
            followers: 1250
        },
        products: [
            {
                id: 1,
                name: '保温饭盒',
                description: '保温效果好，双层隔热',
                image: '',
                stats: {
                    exposure: '5次曝光',
                    likes: '上千赞赏',
                    comments: '手写'
                }
            },
            {
                id: 2,
                name: '防晒霜',
                description: 'SPF50+，防水防汗',
                image: '',
                stats: {
                    exposure: '6次曝光',
                    likes: '上千赞赏',
                    comments: '3千评'
                }
            },
            {
                id: 3,
                name: '保湿面霜',
                description: '滋润保湿，适合秋冬',
                image: '',
                stats: {
                    exposure: '7次曝光',
                    likes: '上千赞赏',
                    comments: '1万回'
                }
            }
        ],
        noteTypes: [
            {
                id: 1,
                name: '曝光型笔记',
                description: '最大化内容曝光，提升品牌知名度',
                icon: 'el-icon-trending-up',
                color: '#4285f4'
            },
            {
                id: 2,
                name: '种草型笔记',
                description: '优化内容导购转化，提升销售业绩',
                icon: 'el-icon-shopping-cart-2',
                color: '#34a853'
            },
            {
                id: 3,
                name: '用户型笔记',
                description: '模拟真实用户体验，增强可信度',
                icon: 'el-icon-user',
                color: '#9c27b0'
            }
        ]
    },
    mutations: {
        SET_USER_INFO(state, userInfo) {
            state.user = { ...state.user, ...userInfo }
        },
        ADD_PRODUCT(state, product) {
            state.products.push(product)
        },
        UPDATE_PRODUCT(state, { id, updates }) {
            const index = state.products.findIndex(p => p.id === id)
            if (index !== -1) {
                state.products.splice(index, 1, { ...state.products[index], ...updates })
            }
        }
    },
    actions: {
        updateUserInfo({ commit }, userInfo) {
            commit('SET_USER_INFO', userInfo)
        },
        addProduct({ commit }, product) {
            const newProduct = {
                ...product,
                id: Date.now()
            }
            commit('ADD_PRODUCT', newProduct)
        }
    },
    getters: {
        userInfo: state => state.user,
        products: state => state.products,
        noteTypes: state => state.noteTypes
    }
})
